import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import tippy from 'tippy.js';

import gommeStore from "../stores/gomme-store.js";

import { WheelSearchByCar } from "./search/wheel-search-by-car.jsx";
import { AddToCartButton } from './cart/add-to-cart-button.jsx';
import { WheelsDaddy } from './results/wheels-daddy.jsx';
import { WheelsPromotedList } from './search/wheel-promoted-list.jsx';
import { WarningCompile } from './search/warning-compile.jsx';

//Sentry.init({
//  dsn: "https://ea99d966321a42ec8e788e49d7e8ac23@o475174.ingest.sentry.io/5512844",
//  integrations: [
//    new Integrations.BrowserTracing(),
//  ],

//  // We recommend adjusting this value in production, or using tracesSampler
//  // for finer control
//  tracesSampleRate: 1.0,
//});


tippy('[data-tippy-content]');
  
var elements = document.querySelectorAll('.add-to-cart-button');
[].forEach.call(elements, function (elem) {
  var tireresult = elem.dataset.tireresult;
  var wheelresult = elem.dataset.wheelresult;
  var spareresult = elem.dataset.spareresult;
  var wheelid = elem.dataset.wheelid;
  var car = elem.dataset.car;
  var year = elem.dataset.year;
  var text = elem.dataset.text;
  var style = elem.dataset.style;
  var target = elem.dataset.target;
  if (typeof window.globalData != "undefined") {
    if (window.globalData.car) {
      car = window.globalData.car;
    }
    if (window.globalData.wheels) {
      wheelresult = window.globalData.wheels.find(w => w.WheelId == wheelid);
    }
  }
  else {
    car = car ? JSON.parse(car) : null;
    wheelresult = wheelresult ? JSON.parse(wheelresult) : null;
  }
  ReactDOM.render(
    <Provider store={gommeStore}>
      <AddToCartButton
        tireresult={tireresult ? JSON.parse(tireresult) : null}
        wheelresult={wheelresult}
        wheelid={wheelid}
        car={car}
        year={year ? year : null}
        text={text}
        style={style}
        target={target} />
    </Provider>,
    elem);
});

var element = document.getElementById('react-wheels-by-cars');
var isSearchPage = (window.globalData || {}).isSearchPage || false;
if (element) {
  var searchType = element.dataset.searchType;
  ReactDOM.render(
    <Provider store={gommeStore}>
      <WheelSearchByCar searchType={searchType} isSearchPage={isSearchPage} />
    </Provider>,
    element
  );
}

var wheelsDaddy = document.getElementById("wheels-daddy");
if (wheelsDaddy) {
  var year = wheelsDaddy.dataset.year;
  var car = window.globalData.car;
  var wheels = window.globalData.wheels;
  var hideFilters = wheelsDaddy.dataset.hidefilters;
  var hideLoadMore = wheelsDaddy.dataset.hideloadmore;
  var selectedDiameter = wheelsDaddy.dataset.selecteddiameter;
  var iDisplayLength = wheelsDaddy.dataset.idisplaylength;

  ReactDOM.render(
    <WheelsDaddy
      year={year}
      car={car}
      wheels={wheels}
      hideFilters={hideFilters}
      hideLoadMore={hideLoadMore}
      selectedDiameter={selectedDiameter}
      iDisplayLength={iDisplayLength} />,
    wheelsDaddy
  );
}

var wheelsPromotedList = document.getElementById("wheel-promoted-list");
if (wheelsPromotedList) {
  var iDisplayLength = wheelsPromotedList.dataset.idisplaylength;

  ReactDOM.render(
    <Provider store={gommeStore}>
      <WheelsPromotedList
        iDisplayLength={iDisplayLength} />
    </Provider>,
    wheelsPromotedList
  );
}

var warningCompile = document.getElementById("warning-compile");
if (warningCompile) {
  ReactDOM.render(
    <WarningCompile />,
    warningCompile
  );
}

